module.exports = __webpack_public_path__ + "static/5-17014a871112b22bca8ae11bd9c9b0aa.jpg";